import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = {
  class: "grid",
  style: {"min-height":"100%"}
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = {
  key: 0,
  class: "card flex justify-content-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pr-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Trường Đại học Giao thông vận tải",
    src: _imports_0,
    class: "max-w-full"
  })
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "p-error flex flex-column gap-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "underline" }, "Lưu ý:", -1)
const _hoisted_9 = {
  key: 1,
  class: "col-12"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-3xl" }, "Bạn đã cập nhật thành công", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "flex flex-column gap-2"
}
const _hoisted_13 = { class: "p-error" }

import { computed, onMounted, ref, watch } from "vue";
import Card from 'primevue/card';
import ProgressSpinner from 'primevue/progressspinner';
import Dialog from 'primevue/dialog';
import CommonDetail from "@/components/CommonDetail.vue";
import { OptionItem, Options } from "@/models/Options.model";
import { MethodResult } from "@/models/MethodResult.model";
import MinhChung from "@/components/MinhChung.vue";
import Button from "primevue/button";
import axios, { AxiosError } from "axios";
import { useRoute } from "vue-router";
import moment from "moment";
import { bool, boolean } from "yup";

const __default__ = {
    name: "App",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const breakpoints = { '960px': '75vw', '641px': '100vw' }
const optionsPriorityAreas = ref<OptionItem[]>([]);
const loading = ref(true);
const token = ref('');
const router = useRoute();
const registration = ref();
const validateMessages = ref<(string | undefined)[]>([]);
const visibleNotice = ref(false);
const success = ref(false);
const isPriorityArea = computed<boolean>(() => {
    const priorityAreaOptions = optionsPriorityAreas.value;
    if (priorityAreaOptions.length) {
        if (registration.value.priorityAreaId != null) {
            const item = priorityAreaOptions.find(x => x.value == registration.value.priorityAreaId);
            if (item && item.metadata.proofRequired) {
                return true;
            }
        }
    }
    return false;
})
onMounted(async () => {
    await initializeAsync().then(() => {
        console.log('ok')
    }).catch((err) => {
        console.error(err);
    }).finally(() => {
        loading.value = false;
    });
})
const initializeAsync = async () => {
    const storage = localStorage.getItem("priorityAreas");
    const priorityAreasOpt = JSON.parse(storage ?? "") as OptionItem[];
    if (!priorityAreasOpt) {
        const responseOptions = await axios.get<MethodResult<Options>>('/helper/options');
        const responseOptionsData = responseOptions.data;
        if (responseOptionsData.data) {
            optionsPriorityAreas.value = responseOptionsData.data.priorityAreas;
            if (responseOptionsData.data.priorityAreas.length) {
                localStorage.setItem("priorityAreas", JSON.stringify(responseOptionsData.data.priorityAreas));
            }
        }
    } else {
        optionsPriorityAreas.value = priorityAreasOpt
    }
    token.value = router.params && router.params.token ? router.params.token as string : '';
    if (token.value) {
        await axios.get(`/registration/cap-nhat-minh-chung/${token.value}`).then(res => {
            registration.value = res.data.data;
        }).catch((err) => {
            console.error(err);
        });

    }
}
const onUpdate = async () => {
    success.value = false;
    const url = token.value ? `/registration/cap-nhat-minh-chung/${token.value}` : '';
    if (url) {
        validateMessages.value = [];
        await axios.post<MethodResult<any>>(url, registration.value).then(res => {
            visibleNotice.value = false;
            const response = res.data;
            if (response.type == 'INVALID') {
                const messsages: any = {};
                if (response.invalidMessages) {
                    for (const key in response.invalidMessages) {
                        messsages[key] = response.invalidMessages[key][0];
                    }
                }
                if (messsages) {
                    validateMessages.value = Object.values(messsages);
                }
            }
            if (response.type == 'DATA') {
                const data = response.data;
                if (!data.success) {
                    validateMessages.value.push(data.errorMessage)
                } else {
                    success.value = true;
                }
            }
        }).catch((err: AxiosError) => {
            if (err.status == 400) {
                validateMessages.value.push('Dữ liệu không hợp lệ vui lòng kiểm tra lại');
            } else {
                validateMessages.value.push('Máy chủ đang bận vui lòng thử lại sau.');
            }
        }).finally(() => {
            if (validateMessages.value.length) {
                visibleNotice.value = true;
            }
        })
    }

}
watch(() => success.value, (val: boolean) => {
    let timeOut;
    if (val) {
        timeOut = setTimeout(() => {
            success.value = false;
            location.reload()
        }, 5000);
    } else {
        clearTimeout(timeOut);
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(ProgressSpinner))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(Card), { class: "form-container" }, {
        header: _withCtx(() => [
          _hoisted_4
        ]),
        title: _withCtx(() => [
          _createTextVNode(" CẬP NHẬT MINH CHỨNG HỒ SƠ ĐĂNG KÝ XÉT TUYỂN ĐẠI HỌC CHÍNH QUY ")
        ]),
        content: _withCtx(() => [
          (registration.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(CommonDetail, {
                  registration: registration.value,
                  "update-file": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(MinhChung, {
                      "is-ielts-mark": registration.value.ieltsMark != null && registration.value.ieltsMark != '',
                      "is-priority-area": isPriorityArea.value,
                      "is-priority-object": registration.value.priorityObject != null && registration.value.priorityObject.text != null,
                      anhHocBaTrangDau: registration.value.anhHocBaTrangDau,
                      "onUpdate:anhHocBaTrangDau": _cache[0] || (_cache[0] = ($event: any) => ((registration.value.anhHocBaTrangDau) = $event)),
                      anhHocBaLop10: registration.value.anhHocBaLop10,
                      "onUpdate:anhHocBaLop10": _cache[1] || (_cache[1] = ($event: any) => ((registration.value.anhHocBaLop10) = $event)),
                      anhHocBaLop11: registration.value.anhHocBaLop11,
                      "onUpdate:anhHocBaLop11": _cache[2] || (_cache[2] = ($event: any) => ((registration.value.anhHocBaLop11) = $event)),
                      anhHocBaLop12: registration.value.anhHocBaLop12,
                      "onUpdate:anhHocBaLop12": _cache[3] || (_cache[3] = ($event: any) => ((registration.value.anhHocBaLop12) = $event)),
                      anhChungChiIelts: registration.value.anhChungChiIelts,
                      "onUpdate:anhChungChiIelts": _cache[4] || (_cache[4] = ($event: any) => ((registration.value.anhChungChiIelts) = $event)),
                      anhCanCuocCongDanMatTruoc: registration.value.anhCanCuocCongDanMatTruoc,
                      "onUpdate:anhCanCuocCongDanMatTruoc": _cache[5] || (_cache[5] = ($event: any) => ((registration.value.anhCanCuocCongDanMatTruoc) = $event)),
                      anhCanCuocCongDanMatSau: registration.value.anhCanCuocCongDanMatSau,
                      "onUpdate:anhCanCuocCongDanMatSau": _cache[6] || (_cache[6] = ($event: any) => ((registration.value.anhCanCuocCongDanMatSau) = $event)),
                      anhDoiTuongUuTien: registration.value.anhDoiTuongUuTien,
                      "onUpdate:anhDoiTuongUuTien": _cache[7] || (_cache[7] = ($event: any) => ((registration.value.anhDoiTuongUuTien) = $event)),
                      anhKhuVucUuTien: registration.value.anhKhuVucUuTien,
                      "onUpdate:anhKhuVucUuTien": _cache[8] || (_cache[8] = ($event: any) => ((registration.value.anhKhuVucUuTien) = $event))
                    }, null, 8, ["is-ielts-mark", "is-priority-area", "is-priority-object", "anhHocBaTrangDau", "anhHocBaLop10", "anhHocBaLop11", "anhHocBaLop12", "anhChungChiIelts", "anhCanCuocCongDanMatTruoc", "anhCanCuocCongDanMatSau", "anhDoiTuongUuTien", "anhKhuVucUuTien"]),
                    _createVNode(_unref(Button), {
                      label: "Cập nhật minh chứng",
                      onClick: onUpdate,
                      icon: "pi pi-pencil"
                    })
                  ]),
                  _: 1
                }, 8, ["registration"]),
                (registration.value?.updateAttachmentsToken && registration.value?.updateAttachmentsToken.token)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("small", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("i", null, "Thời hạn cập nhật minh chứng đến ngày " + _toDisplayString(_unref(moment)(registration.value?.updateAttachmentsToken.expiry).format('DD/MM/YYYY HH:mm:ss')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                  : _createCommentVNode("", true),
                _createVNode(_unref(Dialog), {
                  visible: visibleNotice.value,
                  "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((visibleNotice).value = $event)),
                  modal: "",
                  header: "Thông báo",
                  breakpoints: breakpoints,
                  contentClass: "w-full",
                  style: { width: '30vw' }
                }, {
                  footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      label: "Đóng",
                      icon: "pi pi-times",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (visibleNotice.value = false)),
                      text: ""
                    })
                  ]),
                  default: _withCtx(() => [
                    (validateMessages.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validateMessages.value, (message, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createElementVNode("span", _hoisted_13, _toDisplayString(message), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["visible"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})